/**
 * Iridium AGM signal bar icon (EN-1501).
 *
 * lastSignalStrength is a discrete bar count (1–5), not dBm. Comparison must
 * use === — assignment (=) made the first branch always win and mutated the
 * device object on render.
 */
export function iridiumSignalIconSrc(
  strength: number | null | undefined
): string {
  if (strength === 5) return 'signal-5.png';
  if (strength === 4) return 'signal-4.png';
  if (strength === 3) return 'signal-3.png';
  if (strength === 2) return 'signal-2.png';
  return 'signal-1.png';
}
